module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "transition": "slide-up",
      "fullscreen": "",
      "content-class": "mobile-comment-dialog"
    },
    model: {
      value: (_vm.initComment),
      callback: function($$v) {
        _vm.initComment = $$v
      },
      expression: "initComment"
    }
  }, [_c('div', {
    staticClass: "dflex top-wrapper"
  }, [_c('div', {
    staticClass: "centerLogo text-center flex-grow"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/images/nav_logo_primary.png"),
      "width": "120"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": require("../../../../static/images/ic_close_dark.svg")
    },
    on: {
      "click": function($event) {
        _vm.closeCommentDialog()
      }
    }
  })]), _vm._v(" "), (_vm.isAssocPassed) ? _c('div', {
    staticClass: "_assoc"
  }, [_vm._t("_assoc")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "width100 comments-comp",
    class: {
      isAssocPassed: _vm.isAssocPassed
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__content",
    class: {
      'no-comment': !_vm.comments.length
    }
  }, [(!_vm.hideComments && _vm.comments.length) ? _c('chat', {
    attrs: {
      "items": _vm.comments,
      "hideDatedString": "",
      "showShortAge": ""
    }
  }) : _c('div', {
    staticClass: "nocomment-msg"
  }, [_vm._v("\n          Please be respectful when leaving comments & follow our "), _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_c('strong', [_vm._v("Community Guidelines")])])], 1)], 1)]), _vm._v(" "), _c('comment-input', {
    attrs: {
      "item": _vm.item,
      "roundInput": _vm.roundInput,
      "noBorder": _vm.noBorder,
      "placeholder": _vm.placeholder,
      "aviHeight": _vm.aviHeight,
      "aviWidht": _vm.aviWidth
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17bf23cd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/components/mobileComments.vue
// module id = 1626
// module chunks = 180